import { Component, ElementRef, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { OperativoService } from 'src/app/proceso-operativo/opeartivo.service';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { PdfService } from '../../../Directivas/PdfService';
import { Router, RouterModule } from '@angular/router';
import { EstatusProyecto } from 'src/app/shared/model/proceso/estadoProyecto';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { comentariosOportunidad } from 'src/app/proceso-operativo/modelos/comentariosOportunidad.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { EmpleadoService } from 'src/app/empleado/empleado.service';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import { Persona } from 'src/app/shared/model/security/persona.model';
import { Puesto } from 'src/app/shared/model/empleado/puesto.model';
import { EvidenciaOportunidad } from 'src/app/shared/model/gestion-proyectos/evidenciasOportunidad';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { SeguimientoOportunidadBaseComponent } from '../../seguimiento-oportunidad.component';
import { ArchivosUtileriasService } from 'src/app/utilerias/service/archivo-utilerias.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { AsigEmpComponent } from '../../agregar-empleados-proyecto/add-emp-proy.component';

@Component({
    selector: 'app-seguimiento-oportunidad-odp',
    standalone: true,
    templateUrl: './seguimiento-oportunidad-odp.component.html',
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatSelectModule,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatDialogModule,
      NgxMatSelectSearchModule,
      MatDatepickerModule,
      AsigEmpComponent
    ],
    styleUrls: ['./../../seguimiento-oportunidad.component.css']
})
export class SeguimientoOportunidadOdpComponent extends SeguimientoOportunidadBaseComponent {
  infoProyecto: Proyecto = new Proyecto();
  contenido: any;
  nombreFile: string;
  @ViewChild('downloadDocument') private download: ElementRef;
  objectEtapa: Proyecto;
  recursosDesarollo: Empleado[];
  datosOportunidad: Proyecto = new Proyecto();
  requestEmpleados = new ConsultaList<Empleado>();
  listLider: Empleado[];
  isValid = false;
  titulo: string = "";
  listaEstimacionGuardada: EvidenciaOportunidad[] = [];
  listaArchivosGralGuardada: EvidenciaOportunidad[] = [];
  
  constructor(
    protected service: OperativoService,
    protected dialog: MatDialog,
    protected sanitizer: DomSanitizer,
    private  readonly router: Router,
    protected pdfService: PdfService,
    protected msg: Msg,
    private readonly empleadosService: EmpleadoService,
    protected archivoService: ArchivosUtileriasService) { 
      super(service, pdfService, msg, dialog, sanitizer,archivoService);
    }

  ngOnInit() {
    this.infoProyecto = JSON.parse(localStorage.getItem('datoProyecto'))
    this.objectEtapa = this.infoProyecto;
    if (this.infoProyecto.estado === "EST_SOL_ODP" || this.infoProyecto.estado === "EST_SOL_LID") {
      this.titulo = "SeguimientoODP";
    }
    else if (this.infoProyecto.estado === "REV_ODP") {
      this.titulo = "SeguimientoRevODP";
    }
    this.consultarComentarios(this.infoProyecto.idGit);
    this.infoProyecto.comentarios.forEach(element => {
      element.estatus = EstatusProyecto[element.estado.toString()];
    });
       
    this.infoProyecto.archivos.forEach(file => {
      let lowerCaseFileName = file.name.toLowerCase(); 
    
      if (this.regexFormatoEstimacion.test(lowerCaseFileName)) {
        this.listaEstimacionGuardada.push(file);
      } else {
        this.listaArchivosGralGuardada.push(file);
      }
    });
    this.requestEmpleados = new ConsultaList<Empleado>();
    this.requestEmpleados.regXPagina = 1000;
    this.requestEmpleados.regInicial = 0;
    this.requestEmpleados.bean = new Empleado();
    this.requestEmpleados.bean.usuario = new Usuario();
    this.requestEmpleados.bean.persona = new Persona();
    this.requestEmpleados.bean.puesto = new Puesto();
    this.consultarLideresDesarrollo();
  }

  private consultarLideresDesarrollo(): void {
    this.requestEmpleados.bean.puesto.id = 1;
    this.requestEmpleados.bean.puesto.id_area = 1;
    this.empleadosService
      .consultaEmpleadosPorPuesto(this.requestEmpleados)
      .subscribe(response => {
        if (response.list.length !== 0) {
          this.listLider = response.list;
        }
      });
  }

  public regresarEvent() {
    if (this.infoProyecto.estado == "EST_SOL_ODP") {
      this.getConfirmacionRegresar().fire().then((resultado) => {
        if (resultado.isConfirmed) {
          this.router.navigate(['PROCESO/oportunidadODP']);
        }

      });
    }else{
      this.router.navigate(['PROCESO/oportunidadODP']);
    }
 
  }

  public resourcesSelectedDevelopers(items: Array<Empleado>): void {
    this.recursosDesarollo = items??[];
   
  }

  public guardarOportunidadEvent() {
    this.infoProyecto.comentarios = this.listaComentarios;
    this.datosOportunidad = this.infoProyecto;
    this.datosOportunidad.colaboradores = this.recursosDesarollo;
    this.listLider.forEach(element => {
      if (element.idEmpleado === this.datosOportunidad.id_lider) {
        this.datosOportunidad.nombreLider = element.persona.nombreCompleto;
      }
    });
    this.service.guardarOportunidadSeguimiento(this.datosOportunidad).subscribe(respuesta => {
      if (respuesta.pCodRetorno === "00000") {
        this.msg.showSuccessNotification("top","Oportunidad actualizada exitosamente.");
        this.router.navigate(['PROCESO/oportunidadODP']);
      }
      else if (respuesta.pCodRetorno.startsWith("244")){//errores de git
        this.msg.showWarningNotification("top","La oportunidad se guardó pero ocurrieron errores de git. " + respuesta.pMensaje.toLowerCase());
        this.router.navigate(['PROCESO/oportunidadODP']);
      }
      else {
        this.msg.showErrorNotification("top","Ocurrió un problema al actualizar la oportunidad.");
      }
    });
  }

  public selectedBoss(value) {
    this.sonRecursosValidos();
  }

  private sonRecursosValidos(): void {
    this.isValid = (this.recursosDesarollo && this.recursosDesarollo.length > 0);
  }

  public rechazarOportunidadEvent() {
    this.getComentarioRechazo().fire({ title: "La oportunidad regresará a 'Estimación por líder'"})
    .then((resultado) => {
      if (resultado.value) {
            this.rechazarOportunidadService(resultado.value);
          }
        });
  }

  private  rechazarOportunidadService(comentario: string) {
      this.infoProyecto.comentarios = this.listaComentarios;
      this.service.rechazarSolicutd(this.infoProyecto).subscribe(resultado => {
        if (resultado.pCodRetorno === "00000") {
          this.msg.showSuccessNotification("top"," La solicitud ha sido rechazada.");
          this.guardarComentarioService(this.infoProyecto,comentario );
          this.router.navigate(['PROCESO/oportunidadODP']);
        }
        else {
          this.msg.showErrorNotification("top","Ocurrió un problema al rechazar la oportunidad.");
          }
        
      });
  }

  public reenviarOportunidadLiderEvent(){ 
    this.enviarOportunidadODPEvent();
  }
 
  public enviarOportunidadODPEvent() {
    if (this.infoProyecto.id_lider != undefined && this.infoProyecto.id_lider != null) {
      this.solicitarComentarioEnviarOportunidad();
    } else {
      this.msg.showErrorNotification("top","Es necesario seleccionar un líder.");
    }

  }

  private solicitarComentarioEnviarOportunidad() {
    this.getComentarioCambioEstado().fire({ title:this.getTituloComentarioEnviarOportunidad()}).then((resultado) => {
    if (resultado.value) {
      let comentariodata: comentariosOportunidad = new comentariosOportunidad();
      comentariodata.contenido = resultado.value;
      comentariodata.idGit = this.infoProyecto.idGit;
      comentariodata.estado = this.infoProyecto.estado;
      comentariodata.archivosComentarios = [];
      this.enviarOportunidadService(comentariodata);
    }
  });
  }

  private getTituloComentarioEnviarOportunidad(): string {
    if (this.infoProyecto.estado === "EST_SOL_ODP") {
      return "Enviar solicitud de estimación a líder";
    } else if (this.infoProyecto.estado === "EST_SOL_LID") {
      return "Reenviar solicitud de estimación a líder";
    }else
      return "Enviar oportunidad a marketing";
  }

  private enviarOportunidadService(comentarioData:comentariosOportunidad){
    
    let datosOportunidad = _.cloneDeep(this.infoProyecto);
    datosOportunidad.colaboradores = this.recursosDesarollo;
    datosOportunidad.comentarios = this.listaComentarios;
    this.listLider.forEach(element => {
      if (element.idEmpleado === datosOportunidad.id_lider) {
        datosOportunidad.nombreLider = element.persona.nombreCompleto;
      }
    });
    if (this.infoProyecto.estado === "EST_SOL_LID"){
      datosOportunidad.estado = "EST_SOL_ODP";
    }
    this.infoProyecto.comentarios = this.listaComentarios;
    this.service.enviarOportunidad(datosOportunidad).subscribe(respuesta => {
      if (respuesta.pCodRetorno === "00000") {
        this.msg.showSuccessNotification("top"," Oportunidad actualizada exitosamente.");
        this.router.navigate(['PROCESO/oportunidadODP']);
        this.service.guardarComentarioOportunidad(comentarioData).subscribe(res => {
          console.log(res)
        });
      } 
      else if (respuesta.pCodRetorno.startsWith("244")){//errores de git
        this.msg.showWarningNotification("top","La oportunidad se guardó pero ocurrieron errores de git. " + respuesta.pMensaje.toLowerCase());
        this.router.navigate(['PROCESO/oportunidadODP']);
      }
      else  {
        this.msg.showErrorNotification("top"," Ocurrió un problema al actualizar la oportunidad.");
      }
      
    });
  }

   

}

